import { PopupModal } from "components/modals/ModalBox";
import React from "react";
import useButtonLoader from "hooks/useButtonLoader";
import { changeStatusUserAPI } from "services/user";
import { toastMessage } from "utils/toastMessage";

const ChangeSelectedUserStatus = ({
  selectedUserDetail,
  onClose,
  setUserList,
  userStatusModal,
  refetchUserList
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // change delete handler
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const reqData = {
        _id: selectedUserDetail?._id || "",
        status: selectedUserDetail.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const { data: responseData, status } = await changeStatusUserAPI(reqData);
      if (status === 200) {
        // Remove the deleted user from the list
        // setUserList((prevList) =>
        //   prevList.map((user) =>
        //     user._id === selectedUserDetail._id
        //       ? { ...user, status: selectedUserDetail.status === "ACTIVE" ? "INACTIVE" : "ACTIVE" } // Toggle the status field
        //       : user
        //   )
        // );
        refetchUserList()
        onClose();
        toastMessage(responseData.message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={userStatusModal}
        handleClose={onClose}
        content={`Are you sure you want to ${selectedUserDetail.status === "ACTIVE" ? "block" : "Unblock"} this user?`}
        title={selectedUserDetail.status === "ACTIVE" ? "Block User" : "Unblock User"}
        buttonLoader={buttonLoader}
        action={changeStatusHandler}
      />
    </>
  );
};

export default ChangeSelectedUserStatus;
